import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a cookie choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    } else if (cookieConsent === 'accepted') {
      // Load Google Analytics if already accepted
      loadGoogleAnalytics();
    }
  }, []);

  const loadGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    loadGoogleAnalytics();
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    // Explicitly deny analytics storage
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm sm:text-base">
            We use Google Analytics to understand how you use our site and improve your experience. 
            By accepting, you consent to our use of cookies for analytics purposes.
          </p>
          <p className="text-xs text-gray-400 mt-2">
            <a href="/cookies-policy" className="text-blue-400 hover:text-blue-300 underline">Cookies Policy</a>
            {' '}&bull;{' '}
            <a href="/privacy-policy" className="text-blue-400 hover:text-blue-300 underline">Privacy Policy</a>
            {' '}&bull;{' '}
            <a href="/terms-and-conditions" className="text-blue-400 hover:text-blue-300 underline">Terms & Conditions</a>
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded text-sm font-medium transition-colors"
          >
            Reject
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded text-sm font-medium transition-colors"
          >
            Accept
          </button>
        </div>
        <button
          onClick={handleReject}
          className="absolute top-2 right-2 sm:hidden"
          aria-label="Close cookie banner"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
